import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { InfoCustomerAreaMessageViewModel } from 'app/shared/prothesis-customer-api-view-models/info-customer-area-message.view-model';
import { Observable } from 'rxjs/internal/Observable';
import { ConfigurationService } from '../../configuration.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerAreaMessageService {
  protected _configurationService = inject(ConfigurationService);
  protected _httpClient = inject(HttpClient);

  protected get _actionUrl(): string {
    return `${this._configurationService.ProthesisCustomerApiAddress}${'/CustomerAreaMessage/'}`;
  }

  public getInfoCustomerAreaMessage(): Observable<InfoCustomerAreaMessageViewModel> {
    return this._httpClient.get<InfoCustomerAreaMessageViewModel>(this._actionUrl);
  }
}
